module.exports = __webpack_public_path__ + "static/media/mision.229f4438.jpg";